import $ from 'jquery';

const VerticalGallery = function (element) {
    window.currentData = JSON.stringify({
        'title': $('title').text(),
        'description': $('meta[property="og:description"]').attr('content'),
        'url': $('meta[property="og:url"]').attr('content'),
        'image': {
            'url': $('meta[property="og:image"]').attr('content'),
            'width': $('meta[property="og:image:width"]').attr('content'),
            'height': $('meta[property="og:image:height"]').attr('content'),
        }
    });

    var _body = document.getElementById('mainarticle-body');
    var _image = event.detail.element[0];
    var type = $(_body).data('type');
    var suffix = '102';
    if (type === 'gallery') {
        suffix = '113';
    }

    if (event.detail.galleryType === "vertical") {
        var head = $('head');
        var articlePermalink = $(_body).data('article-permalink');
        var galleryImageId = $(_image).data('image-id');
        var firstPartNewLink = articlePermalink.replace(suffix + '.html', suffix + '/');
        var newLink = firstPartNewLink.concat(galleryImageId, '.html');
        var figureParent = $(_image).find("[data-id='c-gallery__fig']");
        var h3Element = $(figureParent).find('[data-role="title"]');
        var title = h3Element.length > 0 ? h3Element.text() : $('title', head).text();
        var pElement = $(figureParent).find('[data-role="description"]');
        var description = pElement.length > 0 ? pElement.text() : $('meta[name="description"]', head).attr('content');

        var newData = {
            'title': title,
            'description': description,
            'url': newLink,
            'image': {
                'url': _image.getAttribute('src'),
                'width': _image.getAttribute('width'),
                'height': _image.getAttribute('height'),
            }
        };

        var newJsonData = JSON.stringify(newData);

        if (newJsonData != window.currentData) {

            $('title', head).text(title);
            $('meta[property="og:title"]', head).attr('content', title);
            $('meta[name="title"]', head).attr('content', title);
            $('meta[name="description"]', head).attr('content', description);
            $('meta[property="og:description"]', head).attr('content', description);
            $('meta[name="twitter:description"]', head).attr('content', description);
            $('meta[name="twitter:image:src"]', head).attr('content', newLink);
            $('meta[property="og:image"]', head).attr('content', newLink);
            $('meta[property="og:image:width"]', head).attr('content', _image.getAttribute("width"));
            $('meta[property="og:image:height"]', head).attr('content', _image.getAttribute("height"));
            $('meta[name="twitter:url"]', head).attr('content', newLink);
            $('meta[property="og:url"]', head).attr('content', newLink);

            if (typeof (history.replaceState) !== "undefined") {
                history.replaceState({}, title, newLink);
            }

            if (typeof (gtag) !== 'undefined') {
                gtag('event', 'page_view', {
                    title: document.title,
                    location: location.href,
                    page: location.pathname
                });
            } else if (typeof (ga) !== 'undefined') {
                ga("send", {
                    hitType: "pageView",
                    title: document.title,
                    location: location.href,
                    page: location.pathname
                });
            }

            window.currentData = newJsonData;
        }
    }
};

export default VerticalGallery;